var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-anchor"},_vm._l((_vm.anchors),function(item,index){return _c('anchor-item',{key:index,attrs:{"active":_vm.value == item.value},nativeOn:{"click":function($event){return _vm.click(item)}}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }